import { useEffect, useState } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

const ProjectsSlider = ({ projects, title }) => {
    const [startIndex, setStartIndex] = useState(0);
    // const visibleCount = 3;
    // const isScrollable = projects.length > visibleCount;
    const [visibleCount, setVisibleCount] = useState(3);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 640) {
                setVisibleCount(1);
            } else if (window.innerWidth < 1024) {
                setVisibleCount(2);
            } else {
                setVisibleCount(3);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const isScrollable = projects.length > visibleCount;

    const nextSlide = () => {
        if (startIndex + visibleCount < projects.length) {
            setStartIndex(startIndex + 1);
        }
    };

    const prevSlide = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        }
    };

    return (
        // <div className="Project-network relative w-full max-w-4xl mx-auto">
        <div className="Partners-network relative flex flex-col items-center">
            <h2 className="text-center text-2xl font-bold">{title}</h2>
            <div className="relative flex items-center justify-center mt-6 w-full max-w-[900px]">
                {isScrollable && (
                    <button onClick={prevSlide} 
                    className={visibleCount > 1 ? 'mr-4' : 'absolute left-[-10px] z-10 p-2 bg-white shadow-lg rounded-full ${startIndex === 0 ? "opacity-50 cursor-not-allowed" : ""}'}
                    // className="mr-4" 
                    // className={`absolute left-0 z-10 p-2 bg-white shadow-lg rounded-full ${
                    //     startIndex === 0 ? "opacity-50 cursor-not-allowed" : ""
                    // }`}
                    disabled={startIndex === 0}>
                        <CaretLeft size={20} />
                    </button>
                )}

                <div className="w-full overflow-hidden">
                    <div
                        // className="flex transition-transform duration-500 ease-in-out"
                        className={`flex transition-transform duration-500 ease-in-out ${
                            projects?.length < 3 && visibleCount === 3 ? "justify-center" : ""
                          }`}
                        style={{ transform: `translateX(-${startIndex * (100 / visibleCount)}%)` }}
                    >
                        {projects.map((project, index) => {
                            const hasImage = project.image?.data?.attributes?.url;
                            const hasSubtitle = !!project.sub_title;

                            return (
                                <div
                                    key={project.id}
                                    // className={`project-card w-[260px] flex-shrink-0 mx-2 border rounded-lg flex flex-col`}
                                    className="project-card w-full md:w-[260px] flex-shrink-0 mx-2 border rounded-lg flex flex-col"
                                >
                                    {hasImage && (
                                        <img
                                            src={project.image.data.attributes.url}
                                            alt={project.image.data.attributes.alternativeText || "Project Image"}
                                            className="w-full h-40 rounded-lg"
                                        />
                                    )}

                                    <div className={`${hasImage ? "mt-2" : "mt-0"} flex flex-col p-2`}>
                                        <p className="font-bold mb-2">{project.title}</p>
                                        {hasSubtitle && <TruncatedText text={project.sub_title} />}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {isScrollable && (
                    <button 
                    onClick={nextSlide} 
                    // className="ml-4" 
                    className={visibleCount > 1 ? 'ml-4' : `absolute right-[-10px] z-10 p-2 bg-white shadow-lg rounded-full ${startIndex + visibleCount >= projects.length ? "opacity-50 cursor-not-allowed" : ""}`}
                    // className={`absolute right-0 z-10 p-2 bg-white shadow-lg rounded-full ${
                    //     startIndex + visibleCount >= projects.length ? "opacity-50 cursor-not-allowed" : ""
                    // }`}
                    disabled={startIndex + visibleCount >= projects.length}>
                        <CaretRight size={20} />
                    </button>
                )}
            </div>
        </div>
    );
};

const TruncatedText = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div>
            <p className={`text-sm text-gray-600 ${isExpanded ? "" : "line-clamp-3"}`}>
                {text}
            </p>
            <button
                className="text-blue-600 text-xs font-semibold cursor-pointer"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                {isExpanded ? "Read Less" : "Read More"}
            </button>
        </div>
    );
};

export default ProjectsSlider;
